import { FieldText } from '@dixa/lib-shared-habla';
import * as React from 'react';
import { Field } from 'redux-form';
import { required } from 'redux-form-validators';

import { LanguageCustomizationForm } from '../../types';

type Props = {};

export const FollowupCustomizationFormView: React.FunctionComponent<Props> = (
  props,
) => {
  return (
    <section>
      <Field
        name={LanguageCustomizationForm.Fields.headerText}
        validate={[required()]}
        placeholder="Header message"
        label="Header message"
        component={FieldText}
      />
      <Field
        name={LanguageCustomizationForm.Fields.subheaderText}
        validate={[required()]}
        placeholder="Subheader message"
        label="Subheader message"
        component={FieldText}
      />
      <Field
        name={LanguageCustomizationForm.Fields.placeholderText}
        validate={[required()]}
        placeholder="Placeholder text"
        label="Placeholder"
        component={FieldText}
      />
      <Field
        name={LanguageCustomizationForm.Fields.actionButtonText}
        validate={[required()]}
        placeholder="Call to action"
        label="Button text"
        component={FieldText}
      />
    </section>
  );
};
